<template>
    <div class="completion-page" v-show="isContractAuth">
        <div class="bgc-wrap">
            <img src="@/assets/images/processv2/gasudgui.png" alt="">
        </div>
        <div class="tips">
            <div class="title">尊敬的{{objProject.name}}：</div>
            <div class="content">{{objProject.tips}}</div>
        </div>
        <!-- todo 0720隐藏，需要换新的 -->
        <!-- <div class="standard" v-if="objProject.view_doc==1">
            <img src="@/assets/images/processv2/ascfx.png" alt="">
            <div class="text" @click="toStandard">
                <div class="text-l">查看</div>
                <div class="text-r">《智慧集成系统质量管理标准》</div>
            </div>
        </div> -->
        <div class="report-wrap">
            <template v-for="(item,index) in arrReportList">
                <div class="report-item">
                    <div class="title-date">{{item.date_tips}}</div>
                    <div class="report-content" @click="toDetail(item)">
                        <div class="it-title">
                            <div class="title">{{item.title}}</div>
                            <div class="state" :style="{'color':item.fin_status?'#0D53FC':'#DA822E'}">{{item.fin_status?'已交付':'待交付'}}</div>
                        </div>
                        <div class="it-center">
                            <div class="image-wrap">
                                <div class="img-l">
                                    <template v-for="(imgIt,imgIndex) in item.attach">
                                        <div class="img-w" v-if="imgIndex<4">
                                            <img :src="imgIt" alt="">
                                        </div>
                                    </template>
                                </div>
                                <div class="img-r" v-if="item.fin_status">
                                    <img src="@/assets/images/processv2/dsvgx.png" alt="">
                                </div>
                            </div>
                            <div class="quality">
                                <template v-for="tag in item.cate_list">
                                    <div class="quality-item">
                                        <img v-if="item.fin_status" src="@/assets/images/processv2/dsvgdx.png" alt="">
<!--                                        <img v-else src="@/assets/images/processv2/ds2gdx.png" alt="">-->
                                        <p v-else></p>
                                        <div class="tag-text">{{tag}}</div>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="it-bottom">
                            查看详情
                        </div>
                    </div>
                    <div class="evaluate" @click="toEvalute(item.is_completed)" v-if="(isJGData?(index==arrReportList.length-2 && isSgYs):index==arrReportList.length-1 && isSgYs) || (index==arrReportList.length-1 && isAllYs && item.is_completed && isJGData)" :style="{'background-image':(item.is_completed && JSON.stringify(arrJgEva)!='[]') || (!item.is_completed && JSON.stringify(arrSgEva)!='[]')?'linear-gradient(to right, #EDEFEE 10%, #D3E2DC 90%)':'linear-gradient(to right, #EDEFEE 10%, #F2EAD5 90%)'}">
                        <div class="img-icon">
                            <img v-if="(item.is_completed && JSON.stringify(arrJgEva)!='[]') || (!item.is_completed && JSON.stringify(arrSgEva)!='[]')" src="@/assets/images/processv2/dsv23gx.png" alt="">
                            <img v-else src="@/assets/images/processv2/sdsv23gx.png" alt="">
                        </div>
                        <div class="evaluate-text">
                            <div class="text-t">
                                <div>{{item.is_completed?'系统竣工满意度评价':'系统施工满意度评价'}}</div>
                                <div :style="{'color':(item.is_completed && JSON.stringify(arrJgEva)!='[]') || (!item.is_completed && JSON.stringify(arrSgEva)!='[]')?'#999999':'#355D4B'}">
                                    <span>{{(item.is_completed && JSON.stringify(arrJgEva)!='[]') || (!item.is_completed && JSON.stringify(arrSgEva)!='[]')?'已评价':'评价'}}</span>
                                    <img v-if="(item.is_completed && JSON.stringify(arrJgEva)=='[]') || (!item.is_completed && JSON.stringify(arrSgEva)=='[]')" src="@/assets/images/processv2/d2vgdx.png" alt="">
                                </div>
                            </div>
                            <div class="text-b">
                                已完成系统{{item.is_completed?'竣工':'施工'}}阶段，可点击卡片进行满意度评价~
                            </div>
                        </div>
                    </div>
                    <!-- 虚线上方图标-->
                    <div class="tag-icon" :style="{'background':item.fin_status?'#355D4B':'#D1D9D4'}"></div>
                    <!-- 虚线-->
                    <div class="line"></div>

                </div>
            </template>
        </div>
        <div class="popup" v-if="isAllYs && isJGData && !isShowShare">
            <div class="oFail" v-if="JSON.stringify(arrJgEva)=='[]'" @click="toEvalute(1)">立即验收</div>
            <div class="oSuccess" v-else>竣工验收已完成</div>
        </div>
        <img @click="toHome" class="tohome-icon" src="@/assets/images/processv2/tohome.png" alt="">
        <share v-if="isShowShare" :title="objProject.project_name" :isFixed="true" ref="myShare" track-action="share_report_port"></share>
    </div>
</template>

<script>
import { mapState } from "vuex";
import oDeliver from "@/js/deliver.js";
import share from '../components/share.vue';
import {getReportShare} from "@/js/member/mynews";

export default {
    name: "completionV2",
    data() {
        return {
            isContractAuth:false,
            isShowShare: false,//是否显示分享
            objProject:{},//合同信息
            arrJgEva:[],//竣工评价
            arrSgEva:[],//施工评价
            isAllYs:false,//是否全部已交付
            isSgYs:false,//系统施工是否完全交付
            isJGData:true,//是否有竣工数据
            isSgData:true,//是否有施工数据
            shareTimeLog:null,
        };
    },
    components: {
        share
    },
    computed: {
        ...mapState({
            // 报告列表
            arrReportList: (state) => state.userHouseCompletion.arrReportList,
        }),
    },
    created() {
        let _that = this;
        this.$store.commit("loadSwitch", true);
        $init(()=>{
            if(this.$route.query.form=='wxwork'){
                this.$storage.setStorage('share_source', 'wxwork') //通知过来的
            }
            _that.$oInitData.memberInfo({
                h5_user_id: _that.$storage.getStorage("user_id"),
            }).then((res) => {
                this.isContractAuth=true
                _that.getMeberLists();
            }).finally(f=>{
                if (this.$route.query.shareId>0) {
                    let shareData = {
                        url:window.location.href,
                        project_uuid:this.$route.query.projectmgnid || this.$route.query.project_uuid,
                        id: this.$route.query.shareId,
                    }
                    getReportShare(shareData).then(res=>{
                        shareData.log_id=res.data.data.result.log_id
                        this.shareTimeLog= setInterval(()=>{
                            getReportShare(shareData)
                        },2000)
                    })
                }
            })
            let objSam = this.$route.query;
            if (objSam.sampleroom == 2 || objSam.sampleroom == 3) {
                this.isShowShare = true;
                setTimeout(()=>{
                    this.$refs.myShare.setShare();
                },200)
            }
            if(this.$route.query.projectmgnid){
                this.$storage.setStorage('project_uuid',this.$route.query.projectmgnid)
            }

        })
    },
    beforeDestroy() {
        clearInterval(this.shareTimeLog)
        this.shareTimeLog=null
    },
    methods: {
        toHome(){
            let objSam =this.$route.query;
            this.$router.push(`/member/v2/index/index?sharePersonId=${objSam.sharePersonId || ''}&sampleroom=${objSam.sampleroom || ''}&accountid=${objSam.accountid || ''}&contractid=${objSam.contractid || ''}&systemuserid=${objSam.systemuserid || ''}`)
        },
        // 获取评价详情
        getEvaInfo(type,id){
            oDeliver.evaInfo({type:type,project_uuid:id}).then(res=>{
                if(type==1){
                    this.arrJgEva=res.result
                }else if(type==3){
                    this.arrSgEva=res.result
                }
            })
        },
        // 查看详情
        toDetail(item){
            let objData = this.$route.query;
            let data = {
                sampleroom: objData.sampleroom || '',
                accountid: objData.accountid || '',
                contractid: objData.contractid || objData.contractId || objData.contract_id || '',
                systemuserid: objData.systemuserid || ''
            }
            this.$router.push({
                path:'/member/v2/process/detail',
                query: Object.assign({
                    id:item.rule_report_id,
                    projectmgnid:this.objProject.project_uuid,
                    completed:item.is_completed,
                    sharePersonId:objData.sharePersonId
                },data)
            })
        },
        // 跳转评价
        toEvalute(type){
            if(type){
                // 竣工评价
                let objData = this.$route.query;
                let data = {
                    sampleroom: objData.sampleroom || '',
                    accountid: objData.accountid || '',
                    contractid: objData.contractid || '',
                    systemuserid: objData.systemuserid || ''
                }
                this.$router.push({
                    path:`/member/v2/evaluate/finish`,
                    query:Object.assign({
                        shareId:this.$route.query.shareId || 0,
                        company_id:this.objProject.company_id,
                        contract_id:this.objProject.contract_id,
                        topic_id:this.objProject.topic_id,
                        project_uuid:this.objProject.project_uuid,
                        sharePersonId:this.$route.query.sharePersonId || 0
                    },data)
                })
            }else{
                //施工评价
                let objData = this.$route.query;
                let data = {
                    shareId:this.$route.query.shareId || 0,
                    sampleroom: objData.sampleroom || '',
                    accountid: objData.accountid || '',
                    contractid: objData.contractid || '',
                    systemuserid: objData.systemuserid || '',
                    sharePersonId:this.$route.query.sharePersonId || 0
                }
                this.$storage.setStorage('objProjectEva', JSON.stringify(this.objProject));
                this.$router.push({path:`/member/v2/evaluation/index`,query:data})
            }
        },
        // 跳转施工标准
        toStandard(){
            let objData = this.$route.query;
            let data = {
                sharePersonId:objData.sharePersonId,
                sampleroom: objData.sampleroom || '',
                accountid: objData.accountid || '',
                contractid: objData.contractid || '',
                systemuserid: objData.systemuserid || ''
            }
            window.location.href = `${window.location.origin}/member/v2/standard/index?sampleroom=${data.sampleroom}&accountid=${data.accountid}&contractid=${data.contractid}&systemuserid=${data.systemuserid}`
        },
        // 交付列表a7be00aa-691e-ac44-0000-06288ceee1f6-b13802aa-691e-ac6d-0000-0633f674b76a
        getMeberLists() {
            let _that = this;
            _that.$store.commit("loadSwitch", true);
            oDeliver.memberlistV2({
                    workorder_id:_that.$route.query.workorder_id,
                    projectmgnid: _that.$route.query.projectmgnid || _that.$route.query.project_uuid,
                    sampleroom: this.$route.query.sampleroom || '',
                })
                .then((res) => {
                    _that.$store.commit("loadSwitch", false);
                    // 当前报告列表
                    _that.$store.state.userHouseCompletion.arrReportList =
                        res.result.report;
                    _that.objProject=res.result.project
                    this.getEvaInfo(1,_that.objProject.project_uuid)
                    this.getEvaInfo(3,_that.objProject.project_uuid)
                    // 判断系统施工和全部施工是否已交付
                    let isAll = this.arrReportList.find(it=>{
                        return it.fin_status==0
                    })
                    let isSg = this.arrReportList.find(it=>{
                        if(it.is_completed==0){
                            return it.fin_status==0
                        }
                    })
                    this.isAllYs = isAll?false:true
                    this.isSgYs = isSg?false:true
                    // 判断是否有施工和竣工数据
                    let isSgD = this.arrReportList.find(it=>{
                        return it.is_completed==0
                    })
                    let isJgD = this.arrReportList.find(it=>{
                        return it.is_completed==1
                    })
                    this.isSgData = isSgD?true:false
                    this.isJGData = isJgD?true:false
                });
        },
    },
};
</script>

<style scoped lang="scss">
.completion-page{
    background: #F7F7F7;
    padding-bottom: 180px;
    .tohome-icon{
        position: fixed;
        bottom: 200px;
        right: 50px;
        width: 100px;
        height: 100px;
    }
    .popup{
        position: fixed;
        bottom: 0;
        z-index: 99;
        left: 0;
        width: 100%;
        height: 180px;
        background: #FFFFFF;
        box-shadow: 0px 8px 32px 0px rgba(0,0,0,0.08);
        border-radius: 24px 24px 0px 0px;
        backdrop-filter: blur(0px);
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: env(safe-area-inset-bottom);
        .oFail{
            width: 686px;
            height: 72px;
            background: #355D4B;
            border-radius: 36px;
            font-size: 24px;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 72px;
            text-align: center;
        }
        .oSuccess{
            font-size: 24px;
            font-weight: 800;
            color: #355D4B;
            text-align: center;
        }
    }
    .bgc-wrap{
        width:100%;
        height: 328px;
        //background: skyblue;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .tips{
        width: 100%;
        background: #7AA894;
        border-radius: 24px 24px 0px 0px;
        padding: 64px;
        transform: translateY(-32px);
        .title{
            font-size: 28px;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 42px;
        }
        .content{
            margin-top: 20px;
            text-indent:50px;
            font-size: 26px;
            font-weight: 400;
            color: #FFFFFF;
            text-align: justify;
            line-height: 48px;
        }
    }
    .standard{
        display: flex;
        align-items: center;
        padding: 0 0px 0 32px ;
        img{
            width: 30px;
            height: 32px;
        }
        .text{
            margin-left: 16px;
            font-size: 28px;
            font-weight: 400;
            color: #355D4B;
            display: flex;
            align-items: center;
            .text-l{}
            .text-r{
                font-weight: 600;
                position: relative;
                &:after{
                    content:'';
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    height: 1px;
                    background: #355D4B;
                }
            }
        }
    }
    .report-wrap{
        width: 100%;
        // padding-top: 48px;
        .report-item{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            padding-bottom: 32px;
            position: relative;
            .line{
                position: absolute;
                left: 10px;
                bottom: 0;
                width: 1px;
                height: 100%;
                border-left: 1px dashed #96ABA1;
                z-index: 1;

            }
            .tag-icon{
                position: absolute;
                left: 0;
                top: 70px;
                width: 24px;
                height: 24px;
                background: #355D4B;
                border-radius: 0px 13px 13px 0px;
                z-index: 2;
            }
            &:first-child{
                .line{
                    height: 85%;
                }
            }
            .title-date{
                width: 100%;
                text-align: left;
                font-size: 20px;
                font-weight: 400;
                color: #999999;
                line-height: 30px;
                padding: 0 0 16px 62px;
            }
            .report-content{
                width: 686px;
                border-radius: 24px;
                background: rgba(53, 93, 75, 0.05);
                overflow: hidden;
                .it-title{
                    width: 100%;
                    height: 72px;
                    padding: 0 32px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    background: rgba(53, 93, 75, 0.05);
                    .title{
                        font-size: 24px;
                        font-weight: bold;
                        color: #355D4B;
                    }
                    .state{
                        font-weight: 500;
                        color: #DA822E;
                        line-height: 34px;
                    }
                }
                .it-center{
                    .image-wrap{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 32px 24px;
                        .img-l{
                            display: flex;
                            align-items: center;
                            .img-w{
                                width: 96px;
                                height: 96px;
                                margin-right: 16px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                img{
                                    object-fit: cover;
                                    width:100%;
                                    height: 100%;
                                }
                            }

                        }
                        .img-r{
                            img{
                                width: 126px;
                                height: 116px;
                            }
                        }
                    }
                    .quality{
                        display: flex;
                        flex-wrap: wrap;
                        align-items: center;
                        padding: 0 24px;
                        .quality-item{
                            width: 50%;
                            display: flex;
                            align-items: center;
                            margin-bottom: 22px;
                            img{
                                width: 24px;
                                height: 24px;
                            }
                            p{
                                width: 24px;
                                height: 24px;
                                background: #D1D7D4;
                                border-radius: 50%;
                            }
                            .tag-text{
                                padding-left: 16px;
                                font-size: 26px;
                                font-weight: 400;
                                color: #999999;
                            }
                        }
                    }
                }
                .it-bottom{
                    width: 100%;
                    height: 72px;
                    line-height: 72px;
                    text-align: center;
                    font-size: 28px;
                    font-weight: 500;
                    color: #355D4B;
                    border-top: 1px solid #D1DAD6;

                }
            }
            .evaluate{
                width: 686px;
                height: 160px;
                background: #EFF1F0;
                margin-top: 16px;
                border-radius: 24px;
                display: flex;
                justify-content: space-between;
                padding: 28px 24px;
                .img-icon{
                    img{
                        width: 104px;
                        height: 104px;
                    }
                }
                .evaluate-text{
                    flex: 1;
                    padding: 0 0 0 16px;
                    .text-t{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        div{
                            &:last-child{
                                font-size: 24px;
                                font-weight: bold;
                                color: #355D4B;
                                display: flex;
                                align-items: center;
                                img{
                                    width: 32px;
                                    height: 32px;
                                    margin-left: 10px;
                                }
                            }
                            &:first-child{
                                font-size: 20px;
                                font-weight: 500;
                                color: #355D4B;
                            }
                        }
                    }
                    .text-b{
                        font-size: 20px;
                        font-weight: 400;
                        color: #999999;
                        margin-top: 10px;
                        padding-right: 100px;
                    }
                }
            }
        }
    }
}
</style>
